module.exports = __webpack_public_path__ + "assets/img/bg.dc44b3f9.png";